import { Download } from 'lucide-react'
import { CSVLink } from 'react-csv'
import { type Data, type Headers } from 'react-csv/lib/core'

import { Button } from 'slab'

export function DownloadButton ({
  data,
  headers,
  filename,
  linkClassNames,
  buttonText = 'Download',
  disabled = false,
  variant = 'primary',
  onClick = () => {},
}: {
  data: Data;
  headers: Headers;
  filename: string;
  linkClassNames?: string;
  buttonText?: string;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'tertiary';
  onClick?: () => void;
}) {
  return (
    <CSVLink
      data={data}
      headers={headers}
      filename={filename}
      target='_blank'
      className={linkClassNames}
      onClick={onClick}
    >
      <Button variant={variant} disabled={disabled} leftIcon={Download}>
        {buttonText}
      </Button>
    </CSVLink>
  )
}
